// https://vuex.vuejs.org/en/actions.html
import { firebaseAuth } from "@/firebase/firebaseAuth";
import moment from "moment";
import { getUserObject } from "../services/users";
// import axios from 'axios'
import firestore from "../firebase/firestore";
import router from "../router";
import { getConsumerUnits } from "../services/consumer_units";

export default {
  setLogoutTimer({ commit }, expirationTime) {
    setTimeout(() => {
      commit("clearAuthData");
      router.replace("/login");
    }, expirationTime * 1000);
  },
  logout({ commit }) {
    firebaseAuth
      .signOut()
      .then(() => {
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("expirationDate");
        commit("clearAuthData");
        router.replace("login");
      })
      .catch((error) => {
        console.error(`SingOut Error: ${error}`);
      });
  },
  updateCurrentUser({ commit }, context, data) {
    commit("setCurrentUser", data);
  },
  async login({ commit, dispatch }, authData) {
    return await firebaseAuth
      .signInWithEmailAndPassword(authData.email, authData.password)
      .then((res) => {
        return res.user.getIdToken().then((token) => {
          commit("authUser", {
            idToken: token,
            userId: res.user.uid,
          });
          dispatch("updateCurrentUser", {
            idToken: token,
            userId: res.user.uid,
            ...res.user,
          });
          const now = new Date();
          //Configura o logout para daqui 2 horas
          const expirationDate = new Date(now.getTime() + 7200000);
          localStorage.setItem("token", token);
          localStorage.setItem("userId", res.user.uid);
          localStorage.setItem("expirationDate", expirationDate);
          return res;
        });
      })
      .catch((error) => {
        console.error("Error: ", error);
        return error;
      });
  },
  async setInitialsConfig({ commit, state }) {
    let config = null;
    await firestore
      .collection("config")
      .doc("total_collections")
      .get()
      .then((res) => {
        config = res.data();
        // commit('setConfig', {
        //   ...res.data()
        // })
      })
      .catch((error) => {
        console.error("Error: ", error);
        return error;
      });
    await firestore
      .collection("config")
      .doc("negociacao")
      .get()
      .then((res) => {
        if (config) {
          config = {
            ...config,
            ...res.data(),
          };
        } else {
          config = res.data();
        }
      })
      .catch((error) => {
        console.error("Error: ", error);
        return error;
      });
    await firestore
      .collection("config")
      .doc("utility_company")
      .get()
      .then((res) => {
        if (config) {
          config = {
            ...config,
            ...res.data(),
          };
        } else {
          config = res.data();
        }
      })
      .catch((error) => {
        console.error("Error: ", error);
        return error;
      });
    await firestore
      .collection("config")
      .doc("utility_fare_values")
      .get()
      .then((res) => {
        if (config) {
          config = {
            ...config,
            fares: res.data()?.fares,
          };
        } else {
          config = res.data();
        }
      })
      .catch((error) => {
        console.error("Error: ", error);
        return error;
      });
    await firestore
      .collection("config")
      .doc("groups")
      .get()
      .then((res) => {
        if (res.data()?.groupList) {
          commit("setGroupList", res.data().groupList);
        }
      })
      .catch((error) => {
        console.error("Error: ", error);
        return error;
      });
    await commit("setConfig", config);

    // FIX: Alterar lógica para atribuir permissões ao usuário que loga, para uma maneira mais performática, isso é gambiarra =)
    await firestore
      .collection("permissions")
      .get()
      .then((res) => {
        const permissions = res.docs.map((item) => item.data());

        for (const permission of permissions) {
          const allowed_groups = permission?.allowed_groups?.some((item) =>
            state?.user?.group?.includes(item),
          );
          const allowed_users = permission?.allowed_users?.some(
            (item) => item == state?.user?.email,
          );
          if (allowed_groups || allowed_users || permission?.allow_all) {
            commit(`set_${permission.id}`, true);
          }
          if (permission?.block_all) {
            commit(`set_${permission.id}`, false);
          }
        }
      })
      .catch((error) => {
        console.error("Error: ", error);
        return error;
      });
  },

  async tryAutoLogin({ commit, dispatch, state }) {
    //Valida se token é valido
    const token = localStorage.getItem("token");
    const expirationDate = moment(localStorage.getItem("expirationDate"));
    const now = moment(new Date());

    if (state.publicRoute) {
      return;
    }
    if (!token || !expirationDate) {
      dispatch("logout");
      return;
    }

    let isFunctionCalled = false;

    if (now.isBefore(expirationDate)) {
      await firebaseAuth.onIdTokenChanged((user) => {
        if (isFunctionCalled) return;

        if (user) {
          isFunctionCalled = true;
          dispatch("updateCurrentUser", {
            idToken: token,
            userId: user.uid,
            ...user,
          });
          user
            .getIdToken(true)
            .then(async (token) => {
              const now = new Date();
              //Configura o logout para daqui 2 horas
              localStorage.setItem(
                "expirationDate",
                new Date(now.getTime() + 7200000),
              );
              localStorage.setItem("token", token);
              commit("storeToken", token);

              //Faz o login no usuário toda vez que a tela é reiniciada
              await firestore
                .collection("users")
                .doc(user.uid)
                .get()
                .then(async (res) => {
                  const user = {
                    id: res.id,
                    ...res.data(),
                  };

                  localStorage.setItem("userId", res.id);
                  await commit("storeUser", user);
                  dispatch("setInitialsConfig");

                  const currentURL = window.location.pathname;

                  if (currentURL != "/login") {
                    router.push(currentURL);
                  }
                })
                .catch((err) => {
                  console.error(err);
                  dispatch("logout");
                });
            })
            .catch((err) => {
              console.log(err);
              dispatch("logout");
            });
        } else {
          dispatch("logout");
        }
      });
    } else {
      dispatch("logout");
    }
  },
  queryConsumerUnits(context) {
    return new Promise((resolve) => {
      // const { sortBy, descending, page, rowsPerPage } = context.state.pagination
      let items = [];
      // const direction = descending?"asc":"asc"

      return getConsumerUnits({
        orderBy: { field: "created_at", direction: "asc" },
      }).onSnapshot({ includeMetadataChanges: true }, (res) => {
        const changes = res.docChanges();
        items = changes.map((change) => {
          if (change.type === "added") {
            const customer_id = change.doc.data().user_id;
            // console.log('added: ', customer_id)
            // const user = getUserObject(customer_id)
            const user = getUserObject(customer_id);
            return {
              ...change.doc.data(),
              id: change.doc.id,
              user: user.then((result) => result),
            };
          } else if (change.type === "modified") {
            // const customer_id = change.doc.data().user_id
            // console.log('modified: ', customer_id)
          } else {
            // this.loading = false;
          }
          // var source = res.metadata.fromCache ? "local cache" : "server";
          // console.log("Data came from " + source);
        });
        // console.log('items: ', items)
        context.commit("_setConsumerUnits", items.slice());
        resolve(items);
      });

      // return getConsumerUnitsUsers({ limit: rowsPerPage, page: page, orderBy: { field: sortBy, direction: direction } })
      //   .then(res => {
      //     console.log('res: ', res)

      //     items = res.docs.map(doc => {
      //       return {
      //         id: doc.id,
      //         ...doc.data()
      //       }
      //     })

      //     // let list_items = context.state.items.concat(items)
      //     console.log('list_items: ', items)
      //     let total = items.length
      //     context.commit('_setConsumerUnits', items)
      //     // context.commit('_setItems', { items, total })
      //     resolve({items, total})
      //   })
      //   .catch(error => {
      //     console.error('Erro ao pegar unidades consumidoras')
      //     reject(error)
      //   })
    });
  },
  async getPowerPlants({ commit }) {
    // console.log('inicia getPowerPlants')
    return await firestore
      .collection("power_plants")
      .get()
      .then((powerplants) => {
        const pps = powerplants.docs.map((pp) => {
          const powerplant = {
            id: pp.id,
            ...pp.data(),
          };
          return powerplant;
        });
        commit("setPowerPlants", pps);
        return pps;
      })
      .catch((err) => {
        console.error(err.message);
        commit("setPowerPlants", []);
        return err;
      });
  },
  async getUserByParams({ commit, dispatch }, params) {
    try {
      commit("setLoading", true);
      // console.log('params: ', params)
      if (params) {
        let userRef = firestore.collection("users");
        if (params.email) {
          userRef = userRef.where("email", "==", params.email);
        } else if (params.cpf) {
          userRef = userRef.where("cpf", "==", params.cpf);
        } else if (params.phone) {
          userRef = userRef.where("phone", "==", params.phone);
        }
        return await userRef
          .limit(1)
          .onSnapshot({ includeMetadataChanges: true }, async (users) => {
            // const changes = res.docChanges();
            if (users.size > 0) {
              // console.log('users', {id: users.docs[0].id, ...users.docs[0].data()})
              commit("setCustomer", {
                id: users.docs[0].id,
                ...users.docs[0].data(),
              });
              commit("setUserNotFound", false);
              dispatch("getConsumerUnitsByUser", users.docs[0].id);
              dispatch("getHistoryByUser", users.docs[0].id);
              // this.getConsumerUnitsByUser({commit}, users.docs[0].id)
            } else {
              // console.log('setUserNotFound', users)
              commit("setCustomer", {});
              commit("setUserNotFound", true);
              // console.log('us: ', users)
            }
            commit("setLoading", false);
          });
      }
    } catch (err) {
      commit("setCustomer", {});
      commit("userCSError", err);
      console.error(err);
      commit("setLoading", false);
    }
  },
  setPublicRouteAction({ commit }, publicRoute) {
    commit("setPublicRoute", publicRoute);
  },
};
